import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Building } from '@app/core/models/building.model';

@Injectable({
  providedIn: 'root',
})
export class BuildingService extends BaseService {
  constructor(protected http: HttpClient) {
    super('buildings', http);
  }

  getBuildingsByCustomer(id: number): Observable<Building[]> {
    const params = new HttpParams().set('customerId', id);
    return this.http.get<Building[]>(this.resourceUrl, { params });
  }

  getBuildingsWithMaintenanceRequest(): Observable<Building[]> {
    const params = new HttpParams().set('maintenance', 'true');
    return this.http.get<Building[]>(this.resourceUrl, { params });
  }

  getMaintenanceOverdueCount(): Observable<number> {
    return this.http.get<number>(`${this.resourceUrl}/maintenance-overdue-count`);
  }
}
